import { z } from "zod";

const zCategory = z.enum(["necessary", "analytics", "advertisement", "functionality", "security"]);
const Category = zCategory.Enum;
type Category = z.infer<typeof zCategory>;

export { Category, zCategory };
